import { useState, useEffect } from 'react'
import { db } from '../firebase/config'

// Leest een Partner-record uit de cross-tenant `Partners`-collectie op `.slug`.
//
// We querien op het veld `slug`, niet op doc-ID, omdat doc-IDs in Firestore
// niet hernoemd kunnen worden. Beheerders kunnen daardoor het `slug`-veld
// vrij wijzigen zonder dat de docs opnieuw aangemaakt hoeven te worden.
//
// Spec: docs/features/onboarding-flow.md (T5)
//
// Returnt `{ partner, loading }`:
//   - partner is het document of null (niet gevonden of geen slug)
//   - loading is true tijdens de fetch
const usePartner = (slug) => {

    const [partner, setPartner] = useState(null)
    // `loading` start als true zodra er een slug gevraagd wordt, anders blijft de
    // orchestrator zijn seed-effect uitvoeren met `partner=null` voordat de
    // snapshot-listener een kans heeft gehad.
    const [loading, setLoading] = useState(!!slug)

    useEffect(() => {

        if (!slug) {
            setPartner(null)
            setLoading(false)
            return
        }

        setLoading(true)

        const unsub = db.collection('Partners')
            .where('slug', '==', slug)
            .limit(1)
            .onSnapshot(
                (snap) => {
                    if (snap.empty) {
                        setPartner(null)
                    } else {
                        const doc = snap.docs[0]
                        setPartner({ ...doc.data(), docid: doc.id })
                    }
                    setLoading(false)
                },
                (err) => {
                    console.error('usePartner error for slug', slug, err)
                    setPartner(null)
                    setLoading(false)
                }
            )

        return () => unsub()

    }, [slug])

    return { partner, loading }

}

export default usePartner
